import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ClassInputType } from '../types/class-input-type';
import { RosterUploadFileType } from 'src/app/core/services/http/roster/enums/roster-upload-file-types';

@Component({
  selector: 'app-source-type-select',
  templateUrl: './source-type-select.component.html',
  styleUrls: ['./source-type-select.component.scss']
})
export class SourceTypeSelectComponent {
  rosterUploadFileType = RosterUploadFileType
  @Input() controlName = 'source';
  @Input() form: UntypedFormGroup | undefined;
  @Input() className: ClassInputType = 'app-input';
}
